import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "./globals.css";
import "./tokens.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { App } from "./App";
import { I18nProvider } from "./i18n-provider";
import { SessionProvider } from "./lib/session";
import { ToastProvider } from "./ui/Toast";
import { TooltipProvider } from "./ui/Tooltip";
import { ShellProvider, useTheme } from "./ui/shell";

function PreferenceSync() {
  useTheme();
  return null;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <I18nProvider>
        <ShellProvider>
          <TooltipProvider>
            <ToastProvider>
              <SessionProvider>
                <PreferenceSync />
                <App />
              </SessionProvider>
            </ToastProvider>
          </TooltipProvider>
        </ShellProvider>
      </I18nProvider>
    </BrowserRouter>
  </StrictMode>,
);
